import './rosterItem.css';

export default function RosterItem({ person }) {
    return (
        <li className="roster-item">
            <div>{person.fullName}</div>
            <div><em>{person.institute}</em></div>
            {person.position && <div><strong>{person.position}</strong></div>}
        </li>
    );
}